import React from 'react';
import {NavLink} from 'react-router-dom';
import S from 'StyledAccountMenu.js';
import _map from 'lodash/map';
import accountMenuItems from 'accountMenuItems.enum.js';
import {translation} from 'utilsHelper';

const AccountMenu = ({freebetCount}) => {
    return (
        <S.AccountMenu className="account-menu">
            {_map(accountMenuItems, ({translationKey, href, ...rest}, itemName) => {
                return (
                    <S.AccountMenuItem key={itemName} className="account-menu-item">
                        <S.AccountMenuLink {...rest} as={NavLink} to={href}
                                           activeClassName="active">
                            {translation(translationKey)}
                            </S.AccountMenuLink>
                    </S.AccountMenuItem>
                )
            })}
        </S.AccountMenu>
    );
};

export default AccountMenu;
